module.exports = __webpack_public_path__ + "4ef174012ef2a78ab1dc07d8e5ca964b.svg";